'use client';

import { Divider } from '@/components/divider';
import { BaseModalContent, Modal, ModalButton } from '@/components/modal';
import { Text } from '@/components/text';

import { DistributorField } from './distributor-field';
import { PreferenceField } from './preference-field';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';
import { EnergyType } from '@energy-retailer/constants';

type FilterModalProps = {
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
};

const FilterModal = ({ isModalOpen, openModal, closeModal }: FilterModalProps) => {
  const { property, steps, currentStepNumber } = useJoinFormStore();
  const currentStepFuel = steps[currentStepNumber]?.fuel;

  return (
    <Modal
      heading="Filters"
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      openModal={openModal}
    >
      <BaseModalContent
        buttonComponent={<ModalButton onClick={closeModal}>Done</ModalButton>}
      >
        <div className="flex flex-col gap-e">
          <PreferenceField />

          {(property.electricityDistributors.length > 1 &&
            currentStepFuel === EnergyType.Electricity) ||
            (property.gasDistributors.length > 1 && currentStepFuel === EnergyType.Gas) ? (
            <>
              <Divider />
              <div className="flex flex-col gap-a">
                <Text
                  variant="h3"
                  as="h3"
                >
                  Distributor
                </Text>
                <Text variant="body2">
                  Select the distributor that applies to your address. You can
                  find your distributor on your energy bill.
                </Text>
              </div>
              <DistributorField />
            </>
          ) : null}
        </div>
      </BaseModalContent>
    </Modal>
  );
};

export { FilterModal };
